export default {
  domain: 'y.yunjiglobal.com',
  getlink() {
    let json = { }
    if (document.domain === 'y.yunjiglobal.com') { // 本地代理域名
      json = {
        jiankongUrl: window.location.host,
        refundUrl: window.location.host,
        bussinessHelp: window.location.host,
        pomsMarketing:window.location.host
      }
    } else if (document.domain === 't-do-dev.yunjiglobal.com') { // docker环境域名
      json = {
        jiankongUrl: 'xinyunmonitoradmin-do-dev.yunjiglobal.com/xinyunmonitoradmin',
        refundUrl: 't-do-dev.yunjiglobal.com/refundadmin',
        bussinessHelp: 't-do-dev.yunjiglobal.com',
        pomsMarketing:'t-do-dev.yunjiglobal.com'
      }
    } else if (document.domain === 'customerserviceadmin-do-dev.yunjiglobal.com') { // 云客服的测试环境域名
      json = {
        jiankongUrl: 'customerserviceadmin-do-dev.yunjiglobal.com/yunjixinyunadmin',
        getpage: 'customerserviceadmin-do-dev.yunjiglobal.com/outssoadmin',
        refundUrl: 'customerserviceadmin-do-dev.yunjiglobal.com/yunjixinyunadmin',
        bussinessHelp: '',
        pomsMarketing:'t-do-dev.yunjiglobal.com'
      }
    } else if (document.domain === 'xinyunadmin.yunjiglobal.com') { // 心云现网域名
      json = {
        jiankongUrl: 'xinyunmonitoradmin.yunjiglobal.com/xinyunmonitoradmin',
        getpage: 'outsso.yunjiglobal.com/outssoadmin',
        refundUrl: 'a.yunjiglobal.com/refundadmin',
        bussinessHelp: 'agent.yunjiglobal.com',
        pomsMarketing:'a.yunjiglobal.com'
      }
    } else if (document.domain === 'openxinyun.yunjiglobal.com') { // 云客服现网域名
      json = {
        jiankongUrl: 'openxinyun.yunjiglobal.com/yunjixinyunadmin',
        getpage: 'outsso.yunjiglobal.com/outssoadmin',
        refundUrl: 'openxinyun.yunjiglobal.com/yunjixinyunadmin',
        bussinessHelp: '',
        pomsMarketing:'a.yunjiglobal.com'
      }
    } else {
      json = {
        jiankongUrl: 'xinyunmonitoradmin-dev.yunjiglobal.com',
        refundUrl: 'refundadmin',
        bussinessHelp: 't-do-dev.yunjiglobal.com',
        pomsMarketing:'t-do-dev.yunjiglobal.com'
      }
    }
    return json
  }
}
